import { motion } from "framer-motion";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "How do the sessions work?",
    a: "All sessions are one-on-one video calls with Tony. Book a time that suits you, pay securely by card, and you'll get a confirmation email with your video call link. All session times are shown in Sydney time.",
  },
  {
    q: "Which airlines does this apply to?",
    a: "Tony's experience covers major airlines in both Canada and Australia, and the assessment process he prepares you for — behavioural interviews, group exercises, grooming standards — is used by Qantas, Virgin Australia, Jetstar, Rex and most international carriers recruiting in Australia.",
  },
  {
    q: "What should I prepare before my session?",
    a: "If you can, have the job listing you're applying for handy and think about where you're struggling most — interviews, group exercises, exams, or confidence in general. Tony tailors every session to your situation, so the more context you give him, the more you'll get out of it.",
  },
  {
    q: "I'm already cabin crew — can you help me get promoted?",
    a: "Yes. The Cabin Manager Leadership Mentoring session is built exactly for that: promotion interview preparation, leadership style, handling escalations, and the report-writing and standards expectations that come with the role.",
  },
  {
    q: "I'm in ground school right now — is it too late?",
    a: "Not at all. The Ground School & Training Support session is designed for trainees mid-course. Tony can help with SEP, avmed, ditching and fire training content, study techniques, and exam preparation.",
  },
  {
    q: "Can I reschedule or cancel my booking?",
    a: "Life happens — just reply to your confirmation email and Tony will sort out a new time with you. Please give as much notice as you can so the slot can be offered to someone else.",
  },
  {
    q: "Do you guarantee I'll get hired?",
    a: "No honest mentor can guarantee that — the final decision always sits with the airline. What Tony does guarantee is that you'll walk in knowing exactly what the hiring team is looking for, with honest feedback and a clear plan. That's a genuine edge.",
  },
  {
    q: "How do payments work?",
    a: "Payment is made securely by card when you book, through Stripe. You'll receive a boarding-pass style confirmation email as soon as your payment goes through.",
  },
];

export default function Faq() {
  return (
    <section id="faq" className="py-24 sm:py-32" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-4 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <span className="text-xs uppercase tracking-[0.25em] font-semibold text-sky-700">Questions?</span>
          <h2 data-testid="faq-heading" className="text-3xl sm:text-4xl font-bold tracking-tight mt-3 text-[#0A192F]">
            Frequently asked questions
          </h2>
          <p className="text-slate-500 mt-3 text-sm">
            Anything else? Email Tony directly at tony@cabincrewmentoring.com
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="mt-12"
        >
          <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`faq-${i}`}
                data-testid={`faq-item-${i}`}
                className="rounded-xl bg-white border border-slate-200 px-6 data-[state=open]:border-sky-400 data-[state=open]:shadow-md transition-[border-color,box-shadow] duration-200"
              >
                <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left font-semibold text-[#0A192F] hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent data-testid={`faq-content-${i}`} className="text-slate-600 text-sm leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
